import { render } from "./Index.vue?vue&type=template&id=a271dff6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=a271dff6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a271dff6"

export default script